<template>
    <div class="bottomBox">
        <div class="btn" v-for="(item,index) in bottomBtnList" :key="index" @click="btnClick(index+1)">
            <div class="btnIcon">
                <img :src="item.iconImage" alt="">
            </div>
            <div class="btnMain">{{item.name}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        bottomBtnList: {
            typeof: Array
        }
    },
    data() {
        return {}
    },
    mounted() {},
    methods: {
        btn01Click() {
            this.$emit('childBtn01Click');
        },
        btn02Click() {
            this.$emit('childBtn02Click');
        },
        btn03Click() {
            this.$emit('childBtn03Click');
        },
        btn04Click() {
            this.$emit('childBtn04Click');
        },
        btnClick(value) {
            switch (value) {
                case 1:
                    this.btn01Click();
                    break;
                case 2:
                    this.btn02Click();
                    break;
                case 3:
                    this.btn03Click();
                    break;
                case 4:
                    this.btn04Click();
                    break;
                default:
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scoped >
.bottomBox  {
    width: 100%;
    height: 80px;
    background: url('../../../assets/dataScreen/bottom.png') center top no-repeat;
    background-size: 1905px 124px;
    display: flex;
    justify-content: center;
    padding-top: 14px;
    box-sizing: border-box;
    .btn {
        width: 173px;
        height: 58px;
        margin: 0 14px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btnIcon {
            width: 58px;
            height: 58px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .btnMain {
            width: 108px;
            height: 46px;
            background: url('../../../assets/dataScreen/buttonBg.png') center center no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            color: rgba(255,255,255,0.88);
            font-weight: bold;
        }
    }
}
</style>